import { Card } from "@/components/ui/card";

const Privacy = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section with Image */}
      <div className="relative h-[300px] overflow-hidden">
        <img
          src="https://images.unsplash.com/photo-1488590528505-98d2b5aba04b"
          alt="Privacy Policy Hero"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/50 flex items-center justify-center">
          <h1 className="text-4xl font-bold text-white">Data Privacy Policy</h1>
        </div>
      </div>

      {/* Content Section */}
      <div className="max-w-4xl mx-auto px-4 py-16">
        <Card className="p-8 space-y-8 bg-white shadow-lg">
          <section>
            <h2 className="text-2xl font-semibold mb-4">1. Introduction</h2>
            <p className="text-gray-700">
              This Privacy Policy outlines how Dynamico collects, uses, maintains, and discloses information collected from users of the Dynamico mobile application.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">2. Personal Identification Information</h2>
            <p className="text-gray-700">
              We may collect personal identification information from users in a variety of ways, including, but not limited to, when users visit our app, register on the app, fill out a form, and in connection with other activities, services, features, or resources we make available on our app.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">3. Non-Personal Identification Information</h2>
            <p className="text-gray-700">
              We may collect non-personal identification information about users whenever they interact with our app. Non-personal identification information may include the device name, the type of device, and technical information about users' means of connection to our app.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">4. Web Browser Cookies</h2>
            <p className="text-gray-700">
              Our app may use "cookies" to enhance user experience. Users' devices place cookies on their hard drive for record-keeping purposes and sometimes to track information about them.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">5. How We Use Collected Information</h2>
            <p className="text-gray-700">
              Dynamico may collect and use users' personal information for the following purposes: to run and operate our app, to improve customer service, to personalize user experience, to improve our app, to run a promotion, contest, survey or other app feature, to send users information they agreed to receive about topics we think will be of interest to them.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">6. How We Protect Your Information</h2>
            <p className="text-gray-700">
              We adopt appropriate data collection, storage and processing practices, and security measures to protect against unauthorized access, alteration, disclosure, or destruction of your personal information and data stored on our app.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">7. Sharing Your Personal Information</h2>
            <p className="text-gray-700">
              We do not sell, trade, or rent users' personal identification information to others. We may share generic aggregated demographic information not linked to any personal identification information regarding visitors and users with our business partners, trusted affiliates, and advertisers for the purposes outlined above.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">8. Changes to This Privacy Policy</h2>
            <p className="text-gray-700">
              Dynamico has the discretion to update this privacy policy at any time. When we do, we will post a notification on the main page of our app. We encourage users to frequently check this page for any changes to stay informed about how we are helping to protect the personal information we collect.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">9. Your Acceptance of These Terms</h2>
            <p className="text-gray-700">
              By using this app, you signify your acceptance of this policy. If you do not agree to this policy, please do not use our app.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">10. Contacting Us</h2>
            <p className="text-gray-700">
              If you have any questions about this Privacy Policy, the practices of this app, or your dealings with this app, please contact us.
            </p>
          </section>
        </Card>
      </div>
    </div>
  );
};

export default Privacy;
